var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBv = function SvgBv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bv_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M0 0h512v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    clipPath: "url(#bv_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-68 0h699.7v512H-68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d72828",
    d: "M-93-77.8h218.7v276.2H-93zM249.4-.6h381v199h-381zM-67.6 320h190.4v190.3H-67.5zm319.6 2.1h378.3v188.2H252z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003897",
    d: "M156.7-25.4H221v535.7h-64.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003897",
    d: "M-67.5 224.8h697.8v63.5H-67.5z"
  }))));
};
export default SvgBv;